import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";

export default function EmailNotifications() {
  return (
    <div className="bg-black-950 flex flex-col gap-5 rounded-lg p-5">
      <div className="flex flex-row items-center justify-between">
        <div className="space-y-2">
          <div className="text-lg leading-5 font-bold -tracking-wide text-white">
            Email Notifications
          </div>

          <div className="text-black-500 text-xs leading-3">
            Automatic subscription expiry notifications for Acme Corp
          </div>
        </div>
        <div className="flex flex-row gap-4">
          <Button
            className="gap-2 p-1.5 text-xs leading-normal font-medium tracking-normal text-white hover:bg-white/30 hover:text-white"
            variant="minimal"
            icon
          >
            <i className="ri-send-plane-line text-xs"></i>
            Send email
          </Button>
        </div>
      </div>
      <div className="flex w-full flex-row justify-between">
        <div className="flex w-full flex-row justify-between gap-3">
          <div className="flex w-1/2 flex-col gap-1">
            <p className="text-black-500 text-xs leading-3 font-medium">
              SUBSCRIPTION PLAN
            </p>
            <Select
              onValueChange={(value) => {
                console.log(value);
              }}
              value="7_days"
            >
              <SelectTrigger className="text-black-300 bg-admin-input !h-[45px] w-full !px-5 !py-3 text-sm leading-normal font-medium">
                7 days before expiry
              </SelectTrigger>
              <SelectContent className="!text-black-300 bg-admin-input">
                <SelectItem value="7_days" className="!text-black-300">
                  7 days before expiry
                </SelectItem>
                <SelectItem value="14_days" className="!text-black-300">
                  14 days before expiry
                </SelectItem>
                <SelectItem value="30_days" className="!text-black-300">
                  30 days before expiry
                </SelectItem>
                <SelectItem value="60_days" className="!text-black-300">
                  60 days before expiry
                </SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex w-1/2 flex-col gap-1">
            <p className="text-black-500 text-xs leading-3 font-medium">
              FREQUENCY
            </p>
            <Select
              onValueChange={(value) => {
                console.log(value);
              }}
              value="send_once"
            >
              <SelectTrigger className="text-black-300 bg-admin-input !h-[45px] w-full !px-5 !py-3 text-sm leading-normal font-medium">
                Send once
              </SelectTrigger>
              <SelectContent className="!text-black-300 bg-admin-input">
                <SelectItem value="send_once" className="!text-black-300">
                  Send once
                </SelectItem>
                <SelectItem value="send_daily" className="!text-black-300">
                  Send daily
                </SelectItem>
                <SelectItem value="send_weekly" className="!text-black-300">
                  Send weekly
                </SelectItem>
                <SelectItem value="send_monthly" className="!text-black-300">
                  Send monthly
                </SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-row justify-between">
        <div className="flex w-full flex-col justify-between gap-1">
          <p className="text-black-500 text-xs leading-3 font-medium">
            TEMPLATE
          </p>
          <Textarea
            className="text-black-300 bg-admin-input w-full border-none px-5 py-3 text-sm leading-normal font-medium ring-0 focus-visible:ring-0"
            contentEditable={false}
            readOnly
            defaultValue={`Subject: Subscription Expiring Soon - Action Required 

Dear John Smith, 

This is a friendly reminder that your Metawhale subscription for Acme Corporation is scheduled to expire on 2025-01-15. 

Current Plan: Enterprise 
API Usage: 45,280 / 100,000 calls this month 

To ensure uninterrupted service, please contact your account manager or log in to your dashboard to renew your subscription. 

Best regards, 
The Metawhale Team`}
          />
        </div>
      </div>
    </div>
  );
}
